__turbopack_context__.v({
  "button": "DragButton-module__s0csRW__button",
  "buttonWrapper": "DragButton-module__s0csRW__buttonWrapper",
});
